import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false
import { upload } from '@/utils/axios'
import info from '@/utils/info'
import util from '@/utils/util'
import env from '@/common/env'
import common from '@/common/common'
import './assets/css/global.scss'
import VueScrollTo from 'vue-scrollto'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import i18n from './i18n'
import BaiduMap from 'vue-baidu-map';
//导入中文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

const componentsContext = require.context('./components', false, /\.vue$/)
componentsContext.keys().forEach(component => {
	const componentConfig = componentsContext(component)
	const ctrl = componentConfig.default || componentConfig
	Vue.component(ctrl.name, ctrl)
})

Vue.prototype.$env = env
Vue.prototype.$common = common
Vue.prototype.$upload = upload
Vue.prototype.$info = info
Vue.prototype.$util = util
Vue.prototype.$scrollTo = VueScrollTo

Vue.use(BaiduMap, {
    ak: 'c8AhxwMfYXwFrK73BCcYmAEoBrivGo70'
})

Vue.use(VueAwesomeSwiper)
	
Vue.use(ElementUI,
	{
		zhLocale:zhLocale,
		i18n: (key, value) => i18n.t(key, value) // 在注册Element时设置i18n的处理方法,可以实现当点击切换按钮后，elementUI可以自动调用.js语言文件实现多语言切换
	}
	)
	
// zhLocale.el.pagination = {
//   goto: '跳至',
//   pagesize: '条/页',
//   total: `共计 {total} 条`,
//   pageClassifier: '页',
// }

Vue.use(VueScrollTo, {
	container: 'body', // 滚动元素
	duration: 500, // 动画时长
	easing: 'ease', // 动画曲线
	offset: 0, // 滚动终点距离父元素顶部距离
	force: true, // 强制立即执行，即便元素是可见的
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false, // x 轴禁止滚动
	y: true
})

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
